import styled from 'styled-components';

export const BuildWith = styled.div`
  font-size: 14pt;
  margin-top: 3rem;
  color: #707070;
`;
